export const CONTACT = {
  name: "William",
  email: "William@SalesCan.ca",
  phoneDisplay: "(365) 855-2485",
  phoneTel: "+13658552485",
  address: "110 James St, St. Catharines, ON L2R 7E8",
};

export const mailtoConsult = `mailto:${CONTACT.email}?subject=${encodeURIComponent("Consultation — SalesCan")}`;
